<template>
  <div>
    <store-day v-for="day in storeData.days" :key="day.id" :day="day" :add-range-text="addRangeText" />
  </div>
</template>

<script>
import StoreDay from '@/components/containers/my-company/StoreDay';

export default {
  name: 'StoreHours',
  components: {StoreDay},
  props: {
    addRangeText: {
      type: String,
      default: '',
    },
    storeData: {
      type: Object,
      default: () => {},
    },
    dayLabels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {
    // this could potentally break one day because it is modifying a prop of a prop (propception).
    // :TODO move this to vuex when you get a chance.
    this.storeData.days = this.dayLabels.map((dayLabel, index) => {
      return {
        id: index,
        active: this.storeData.days[index].active,
        name: dayLabel,
        ranges: this.storeData.days[index].ranges.map((range, rangeIndex) => {
          return {
            id: rangeIndex,
            dayName: dayLabel,
            startTime: range.startTime ? range.startTime : '8:00 AM',
            endTime: range.endTime ? range.endTime : '5:00 PM',
          };
        }),
      };
    });
  },
};
</script>
